import { render, staticRenderFns } from "./FreeShippingProgress.vue?vue&type=template&id=efc2160c&scoped=true"
import script from "./FreeShippingProgress.vue?vue&type=script&lang=js"
export * from "./FreeShippingProgress.vue?vue&type=script&lang=js"
import style0 from "./FreeShippingProgress.vue?vue&type=style&index=0&id=efc2160c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc2160c",
  null
  
)

export default component.exports